import { MouseEventHandler, ReactNode } from "react";
import { CheckedIcon, UncheckedIcon } from "../icons";

export type DetailedRowProps = {
  expandedContent?: ReactNode;
  content: ReactNode;
  isExpanded: boolean;
  isSelected: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
};

export const DetailedRow = ({ expandedContent, content, isExpanded, isSelected, onClick }: DetailedRowProps) => {
  return (
    <div className="flex flex-col ">
      <div
        onClick={onClick}
        className="flex items-center gap-4 py-3 border-0 border-b border-solid cursor-pointer border-neutral-200"
      >
        {isSelected ? <CheckedIcon /> : <UncheckedIcon />}
        <div className="grow">{content}</div>
      </div>
      {isExpanded && <div className="py-4">{expandedContent}</div>}
    </div>
  );
};
